export const BASE_LINE_COLOR = '#FF7B08'

export function adjustBrightness(color: string, factor: number): string {
  const [r, g, b] = color
    .replace(/^#/, '')
    .match(/.{1,2}/g)!
    .map((hex) => parseInt(hex, 16))

  const newColor = [
    Math.max(0, Math.min(255, Math.round(r * factor))),
    Math.max(0, Math.min(255, Math.round(g * factor))),
    Math.max(0, Math.min(255, Math.round(b * factor))),
  ]

  return `rgb(${newColor[0]}, ${newColor[1]}, ${newColor[2]})`
}
